import { render, staticRenderFns } from "./forgetPwdModal.vue?vue&type=template&id=c892d564&scoped=true&"
import script from "./forgetPwdModal.vue?vue&type=script&lang=js&"
export * from "./forgetPwdModal.vue?vue&type=script&lang=js&"
import style0 from "./forgetPwdModal.vue?vue&type=style&index=0&id=c892d564&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c892d564",
  null
  
)

export default component.exports